const appInfo = {
    title: 'Presence Hub'
};
export default appInfo;

